<template>
  <div>
  <!-- HEADER -->
<!--  <form-header :show-save-edit="false" :show-toolbox="true" >-->

<!--    &lt;!&ndash; Left side button - primary actions &ndash;&gt;-->
<!--&lt;!&ndash;    <template v-slot:primaryButton>&ndash;&gt;-->
<!--&lt;!&ndash;      <footer-button type="New" @new="newClick"></footer-button>&ndash;&gt;-->
<!--&lt;!&ndash;    </template>&ndash;&gt;-->

<!--    &lt;!&ndash; toolbars &ndash;&gt;-->
<!--    <template v-slot:toolButtons>-->
<!--&lt;!&ndash;      <headers-button-group>&ndash;&gt;-->
<!--&lt;!&ndash;          <b-btn aria-label="undo" variant="plm-toolbar-secondary" title="Undo">&ndash;&gt;-->
<!--&lt;!&ndash;            <font-awesome-icon icon="undo" />&ndash;&gt;-->
<!--&lt;!&ndash;          </b-btn>&ndash;&gt;-->
<!--&lt;!&ndash;        <b-btn aria-label="redo" variant="plm-toolbar-secondary" title="Redo">&ndash;&gt;-->
<!--&lt;!&ndash;          <font-awesome-icon icon="redo" />&ndash;&gt;-->
<!--&lt;!&ndash;        </b-btn>&ndash;&gt;-->
<!--&lt;!&ndash;      </headers-button-group>&ndash;&gt;-->
<!--    </template>-->

<!--    &lt;!&ndash; danger actions on the right &ndash;&gt;-->
<!--&lt;!&ndash;    <template v-slot:dangerButton>&ndash;&gt;-->
<!--&lt;!&ndash;      <footer-button type="Delete" label="Danger!" label-break-point="sm"&ndash;&gt;-->
<!--&lt;!&ndash;                      @delete="deleteClick"></footer-button>&ndash;&gt;-->
<!--&lt;!&ndash;    </template>&ndash;&gt;-->
<!--  </form-header>-->
  <!-- HEADER END-->


  <v-box ref="vbox" :scrollable="true">
    <!-- CONTENT -->
    <b-container class="pt-1 px-2" fluid="true">
      <b-row no-gutters>
        <b-col>
          <div class="tf-tree example">
            <ul class="tf-org">
              <version-chart-node v-if="node" :entityId="effectiveId" :level="0" :tree-config="treeConfig" :node="node"></version-chart-node>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- CONTENT END-->
  </v-box>


  <!-- FOOTER -->
  <footer-navbar >
    <close-button @close="close"></close-button>
  </footer-navbar>
  <!-- FOOTER END -->
  </div>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FormHeader from "@/components/forms/FormHeader";
import FooterButton from "@/components/navbar/FooterButton";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import VBox from "@/components/VBox";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import Rpc from "@/Rpc";
import ActivityManager from "@/activity/ActivityManager";
import VersionChartNode from "@/components/forms/VersionChartNode.vue";
import FormsActions from "@/components/forms/FormsActions";

export default {
  name: "VersionChartActivity",
  components: {VersionChartNode, VBox, CloseButton, FooterNavbar, HeadersButtonGroup, FooterButton, FormHeader},
  permission: Perms.SUPERUSER,
  created(){
    this.title = `${this.form.formTitle} Version Chart`;
    this.loadChart();
  },
  methods: {
    ...Activity.methods,

    navigate(id){
      this.effectiveId = id;
      this.treeConfig.entityId = id;
      this.loadChart();
    },
    openEntity(id){
     if(id === this.entityId){
       this.close();
     } else {
       this.close();
       setTimeout(() => {
         FormsActions.editEntity(this.form, id);
       });
     }
    },

    getTitle() {
      return this.title;
    },
    async canClose(){
      return true;
    },
    async loadChart(){
      this.node = await Rpc.Versioning.getVersionChart(this.form.formClassLong, this.effectiveId);
      this.treeConfig.galleryFieldConf = this.form.fields.find(value => value.fieldName === "gallery");
      this.treeConfig.showGallery = !!this.treeConfig.galleryFieldConf;
    }
  },
  props: {
    form: {required: true, type: FormConfig},
    entityInstance: {required: true},
    entityId: {required: true}
  },
  data:function(){return {
    effectiveId: this.entityId,
    treeConfig: {
      form: this.form,
      masterComponent: this,
      entityId: this.entityId,
    },
    node: null,
    title: "",
    unsavedChanges: false,
    permissions: new PermissionsSet(),
  }}
}
</script>
